import { useEffect, useState } from 'react';
import { apiFetch } from '@/lib/auth';

export interface SteleInfo {
  id: string;
  name: string;
  location: string | null;
  groupId: string | null;
  groupName: string | null;
  status: 'online' | 'offline' | string;
  enabled: boolean;
  lastSeenAt: string | null;
}

/**
 * Welle 9: Stelen des Mandanten samt Online/Offline-Status für das Berater-Dashboard.
 * Pollt regelmäßig, da der Status aus dem Stele-Heartbeat kommt (kein Push an den Berater).
 */
export function useSteles(pollMs = 20000) {
  const [steles, setSteles] = useState<SteleInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await apiFetch('/api/steles');
        if (!res.ok) throw new Error(String(res.status));
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) setSteles(data);
      } catch (e) {
        console.warn('[steles] load failed', e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    const iv = setInterval(load, pollMs);

    function onLogin() { setTick((t) => t + 1); }
    window.addEventListener('bamoa:logged-in', onLogin);

    return () => {
      cancelled = true;
      clearInterval(iv);
      window.removeEventListener('bamoa:logged-in', onLogin);
    };
  }, [tick, pollMs]);

  return { steles, loading };
}
